import { ref } from "vue";

export const updateAvailable = ref(false);

export const setUpdateAvailable = (value) => {
  updateAvailable.value = value;
};
